import Component from "../../lib/Component.js";

const JustWatchRating = ({ selector, element, data }) => {
  const ratingElement = element || (selector ? document.querySelector(selector) : null);
  const originalContent = ratingElement ? ratingElement.innerHTML : null;

  if (!ratingElement || !data) {
    return Component.noop();
  }

  return new Component({
    onMount: () => {
      const range = data.range || "1d";
      if (Object.hasOwnProperty.call(data?.ranks ?? {}, range)) {
        ratingElement.innerHTML = `
          <a title="JustWatch" href="https://justwatch.com${data.full_path}" target="_blank" rel="noopener">
            <span class="rating-logo"></span>
            <span class="rating-value">
              ${data.ranks[range].rank}.
              ${
                data.ranks[range].delta !== undefined
                  ? `<span class="rating-delta ${data.ranks[range].delta >= 0 ? "positive" : "negative"}">
                ${data.ranks[range].delta >= 0 ? "+" : ""}${data.ranks[range].delta}
              </span>`
                  : ""
              }
            </span>
          </a>
        `;
      }
    },
    onUnmount: () => {
      if (ratingElement && originalContent) {
        ratingElement.innerHTML = originalContent;
      }
    },
  });
};

export default JustWatchRating;
